module.exports = __webpack_public_path__ + "img/fulufuxi_logo.586bb8c8.png";